import React from 'react';
import './ProjectsSection.css';
import coat  from '../projects/coatgenix.png';
import clean  from '../projects/cleaningcare.png';
import duku  from '../projects/duku.png';
import mm  from '../projects/mm.png';


const ProjectsSection = () => {
  const projects = [
    {
      id: 1,
      title: "Coatgenix – Where artists thrive, Art lovers thrill",
      tag: "Web Application",
      description: "Coatgenix empowers artists to showcase, promote, and sell their work while inspiring a global art community.",
      link: "https://coatgenix.com/",
      image: coat
    },
    {
      id: 2,
      title: "CleaningCare – Professional Home & Office Cleaning",
      tag: "Web Development",
      link: "https://cleaningcare.au/",
      description: "Eco-friendly cleaning services for homes and businesses across Australia, ensuring spotless spaces with quality and trust.",
      image: clean
    },
    {
      id: 3,
      title: "Duku Creation – Photography Portfolio",
      tag: "Portfolio",
      link: "https://krimin.vercel.app/",
      description: "Showcasing timeless photography that captures stories, emotions, and moments with creativity and precision.",
      image: duku
    },
    {
      id: 4,
      title: "Maitreya Music – Where Melodies Begin",
      tag: "Web Application",
      link: "https://maitreya-music.vercel.app/",
      description: "Whether you're a beginner or a seasoned musician, find your perfect instrument and let the music flow.",
      image: mm
    }
  ];

  return (
    <section className="projects-section">
      <div className="projects-container">
        <h2 className="projects-title">Our Successful Projects</h2>
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                <img src={project.image} alt={project.title} />
                </a>
              </div>
              <div className="project-content">
                <span className="project-tag">{project.tag}</span>
                <h3 className="project-title">
                  <a href={project.link} target="_blank" rel="noopener noreferrer">{project.title}</a>
                </h3>
                <p className="project-description"><a href={project.link} target="_blank" rel="noopener noreferrer">{project.description}</a></p>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="projects-cta">
          <button className="view-all-btn">View All Projects</button>
        </div> */}
      </div>
    </section>
  );
};

export default ProjectsSection; 